import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { JOURNEYS } from "@/data/content";
import { FadeUp, SectionHeading } from "./Reveal";

export const Journeys = () => (
  <section id="journeys" data-testid="journeys-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
    <FadeUp>
      <SectionHeading overline="Find Your Path" title="Four journeys. One continent." />
      <p className="mt-6 max-w-xl text-base leading-relaxed text-jawa-espresso/70">
        Investor, tourist, returnee or expat — JÀWÀ shapes the journey around you.
      </p>
    </FadeUp>

    <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-12">
      {JOURNEYS.map((j, i) => (
        <FadeUp
          key={j.id}
          delay={i * 0.08}
          className={
            i === 0
              ? "lg:col-span-7 lg:row-span-2"
              : i === 3
                ? "lg:col-span-7"
                : "lg:col-span-5"
          }
        >
          <Link
            to={`/journeys/${j.id}`}
            data-testid={`journey-card-${j.id}`}
            className={`group relative block cursor-pointer overflow-hidden ${i === 0 ? "h-[420px] lg:h-full" : "h-[300px]"}`}
          >
            <img
              src={j.image}
              alt={j.title}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-jawa-nearblack/80 via-jawa-nearblack/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-7">
              <p className="text-[10px] uppercase tracking-[0.35em] text-jawa-gold">{j.kicker}</p>
              <div className="mt-2 flex items-center justify-between gap-4">
                <h3 className="font-serif text-3xl font-medium tracking-tight text-jawa-ivory">{j.title}</h3>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-jawa-ivory/70 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-jawa-gold" />
              </div>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-jawa-ivory/75">{j.text}</p>
            </div>
          </Link>
        </FadeUp>
      ))}
    </div>
  </section>
);
